import {EventContainerListDispositionSidePanel} from "~/components/eventContainerDetails/eventContainerListDispositionSidePanel";
import {
    DULUX__EVENT_CONTAINER__NAME__COLUMN_ID,
    duluxDispositionConfig,
} from "~/domainModels/workspaceSpecific/dulux";
import type {EventContainerTemplate} from "~/domainModels/workspaceModules/eventContainersModule";
import type {OttopilotTriggerConfig} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/ottopilotEventContainersWorkspaceCapability/domain/OttopilotEventContainerTriggerConfig";
import type {EventWithEventContainer} from "~/utilities/apis/api";

function getDuluxLeadDisplayName(event: EventWithEventContainer): string {
    const raw = event.eventContainer.additionalColumnValues[DULUX__EVENT_CONTAINER__NAME__COLUMN_ID];
    if (typeof raw === "string" && raw.trim() !== "") {
        return raw.trim();
    }
    return "Lead";
}

export function DuluxLeadDispositionModal(props: {
    onClose: () => void;
    event: EventWithEventContainer;
    eventContainerTemplate: EventContainerTemplate;
    triggerConfiguration: OttopilotTriggerConfig;
    queryKeyPrefix: Array<string | null>;
    onRefreshStateChange?: (isRefreshing: boolean) => void;
}) {
    return (
        <EventContainerListDispositionSidePanel
            {...props}
            dispositionConfiguration={duluxDispositionConfig}
            dispositionUiLevels={4}
            getLeadDisplayName={getDuluxLeadDisplayName}
        />
    );
}
